import * as Bb from 'backbone'
import extend from 'lodash/extend'

/**
 * Инициализация глобальной шины событий
 */
export default extend({}, Bb.Events)
